import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-experience",
  "use": "icon-experience-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-experience\"><defs><style type=\"text/css\"></style></defs><path d=\"M509.9 63.9c-244.7 0-443 198.6-443 443.5S265.3 951 509.9 951s443-198.6 443-443.5-198.3-443.6-443-443.6z m124.9 635.9L510 641.2l-124.8 58.6 17.1-136.9L308 462.1l135.4-26L510 315.2 576.5 436l135.4 26-94.2 100.7 17.1 137.1z\" p-id=\"2628\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol